import React from "react";
import swanLogo from "../../assets/branding/swan-logo.png";
import PrimaryButton from "../layout/PrimaryButton";

const INTRO_STEPS = Object.freeze([
    {
        number: "01",
        title: "Shape the scenario",
        body: "Tell us the loan purpose, timing, security and borrower basics so the file starts with useful context.",
    },
    {
        number: "02",
        title: "Narrow the lender path",
        body: "The workflow turns those answers into a clearer broker review path across bank, non-bank and private options.",
    },
    {
        number: "03",
        title: "Broker review",
        body: "A broker checks the route, confirms what is missing, and follows up with practical next steps.",
    },
]);

function getPartnerName(source) {
    if (String(source || "").toLowerCase().includes("balmoral")) {
        return "Balmoral Commercial Finance";
    }

    return "Financial Edge AX";
}

export default function WebsiteApplicationIntro({ source, onContinue }) {
    const partnerName = getPartnerName(source);

    return (
        <main className="website-application-intro">
            <section className="website-application-intro__shell" aria-labelledby="website-application-intro-title">
                <div className="website-application-intro__content">
                    <div className="website-application-intro__brand" aria-label={`${partnerName} powered by Financial Edge AX`}>
                        <img src={swanLogo} alt="" className="website-application-intro__logo" />
                        <span>{partnerName}</span>
                    </div>

                    <div>
                        <p className="website-application-intro__eyebrow">AI-supported lender matching</p>
                        <h1 id="website-application-intro-title" className="website-application-intro__title">
                            Let's find your lender path.
                        </h1>
                        <p className="website-application-intro__description">
                            A few focused questions help organise your scenario before the full form, so the broker review
                            starts with useful lender-fit context.
                        </p>
                    </div>

                    <div className="website-application-intro__actions">
                        <PrimaryButton type="button" onClick={onContinue} className="website-application-intro__primary">
                            Start
                        </PrimaryButton>
                        <p className="website-application-intro__reassurance">
                            Not a lender approval or credit decision. Your details stay inside the secure application handoff.
                        </p>
                    </div>
                </div>

                <div className="website-application-intro__panel" aria-label="What happens next">
                    <div className="website-application-intro__route" aria-hidden="true">
                        <span className="website-application-intro__route-dot is-active" />
                        <span className="website-application-intro__route-line" />
                        <span className="website-application-intro__route-dot" />
                        <span className="website-application-intro__route-line" />
                        <span className="website-application-intro__route-dot" />
                    </div>

                    <div className="website-application-intro__steps">
                        {INTRO_STEPS.map((step) => (
                            <article key={step.number} className="website-application-intro__step">
                                <span className="website-application-intro__step-number">{step.number}</span>
                                <div>
                                    <h2>{step.title}</h2>
                                    <p>{step.body}</p>
                                </div>
                            </article>
                        ))}
                    </div>

                    <div className="website-application-intro__time">
                        <span>5-7 min</span>
                        <p>Start with the essentials. You can save and continue later.</p>
                    </div>
                </div>
            </section>
        </main>
    );
}
